import Indicadores from '@/services/Indicadores'
export default {
    login(user){
        return Indicadores().post('login/service', user)
    },
    upPass(user){
        return Indicadores().post('login/updatePW', user)
    }
}